import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverListMutations: UpdatesConfig['Mutation'] = {
  waiverListCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverLists', cache);
  },
  waiverListUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverLists', cache);
  },
};

export default waiverListMutations;
